import React, { useEffect, useRef, useState } from 'react';
import {
  Typography,
  Card,
  Tooltip,
  Switch,
  FormControlLabel,
  Select as MUISelect,
  LinearProgress,
} from '@mui/material';
import './OfficeLocationCard.css';
import CreateSharpIcon from '@mui/icons-material/CreateSharp';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import DoneIcon from '@mui/icons-material/Done';
import IconButton from '@mui/material/IconButton';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/system';
import {
  NO_TEXT,
  WARNING_TEXT_FIRST,
  WARNING_TEXT_SECOND,
  YES_TEXT,
} from '../../../../components/ProjectCard/ProjectConstants';
import { DataGrid } from '@mui/x-data-grid';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import KeycloakService from '../../../../services/KeycloakService';
import { DATAGRID_FILTER_CONFIG, UserType } from '../../../../constants';
import AddEmployee from './AddEmployee';
import { DialogBoxComponent } from '../../../../components/DialogBox/DialogBoxCard';
import { Android12Switch } from '../../../../components/ProjectCard/Android12SwitchStyle';
import HttpService from '../../../../services/HttpService';
import { ADMIN_PATH } from '../../../../url';
import ErrorSwitchCase from '../../../../services/ErrorHandlerService';
import { getUserData } from '../../../../services/UserService';

const OfficeLocationCardComponent = (props) => {
  const {
    office,
    currentOfficeId,
    expanded,
    setExpanded,
    getOfficeLocationById,
  } = props;

  const selectNameRef = useRef();
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const [addExpand, setAddExpand] = useState(false);
  const [warning, setWarning] = useState(false);
  const [officeEmployees, setOfficeEmployees] = React.useState([]);
  const [oneOffice, setOneOffice] = React.useState({});
  const [loadTable, setLoadTable] = useState(true);
  const [statusChanged, setStatusChanged] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const [opens, setOpens] = React.useState(false);

  const userId = KeycloakService.getUserDetail();

  const getEmployeeData = async () => {
    const userDetails = await getUserData(userId);
    if (userDetails.isError === false) {
      setUserData(userDetails.data);
    }
  };

  useEffect(() => {
    getEmployeeData();
  }, []);

  const ScrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const _axios = HttpService.getAxiosClient();
  const handleOfficeStatusYes = async () => {
    setOpens(false);
    toggleOfficeStatus();
  };

  const toggleOfficeStatus = async () => {
    const st = oneOffice.status === 'ACTIVE' ? 'ARCHIVED' : 'ACTIVE';
    const payload = {
      id: oneOffice.id,
      tenantId: process.env.REACT_APP_TENANT_ID,
      status: st,
    };
    const updateResponse = await updateOfficeLocation(payload);
    if (updateResponse.isError === false) {
      loadData();
    }
  };

  const loadData = async () => {
    getOffice();
    const EmployeesInOffice = await getEmployeesInOffice(office.id);
    if (EmployeesInOffice.isError === false) {
      setOfficeEmployees((prevUsers) => [...EmployeesInOffice.data.data]);
    }
  };

  const getEmployeesInOffice = async (locationId) => {
    try {
      const response = await _axios.get(
        `${ADMIN_PATH}/office-location/${locationId}/users`,
      );
      return ErrorSwitchCase(response);
    } catch (error) {
      return ErrorSwitchCase(error.response?.data);
    }
  };

  const getOffice = async () => {
    const singleOffice = await getOfficeById(office.id);
    if (singleOffice.isError === false) {
      setOneOffice(singleOffice.data.data[0]);
      setLoading(false);
      setLoadTable(false);
    }
  };

  const getOfficeById = async (locationId) => {
    try {
      const response = await _axios.get(`${ADMIN_PATH}/office-location`, {
        params: { locationId: locationId },
      });
      return ErrorSwitchCase(response);
    } catch (error) {
      return ErrorSwitchCase(error.response?.data);
    }
  };

  const handleOfficeStatusNo = async () => {
    setOpens(false);
  };

  const toggleAddEmployee = () => {
    setAddExpand(!addExpand);
    setWarning(false);
  };

  const handleSubmit = async () => {
    if (selectNameRef.current.name === undefined) {
      setWarning(true);
    } else {
      const payload = {
        id: selectNameRef.current.id,
        tenantId: process.env.REACT_APP_TENANT_ID,
        locationId: office.id,
        dateOfJoining: userData?.dateOfJoining,
        dateOfInternship: userData?.dateOfInternship,
      };
      const response = await updateEmployeeOfficeLocation(payload);
      if (response.isError === false) {
        setAddExpand(false);
        loadData();
        setLoadTable(false);
        toggleAddEmployee();
      } else {
        loadData();
      }
    }
  };

  const toggleEmployeeLocation = (resource) => {
    handleClickOpen(resource);
  };

  const handleClickOpen = (resource) => {
    setStatusChanged(resource);
    setOpen(true);
  };

  useEffect(() => {
    loadData();
  }, []);

  const updateEmployeeOfficeLocation = async (payload) => {
    try {
      const response = await _axios.put(
        `${ADMIN_PATH}/employee/update-employee`,
        payload,
      );
      return ErrorSwitchCase(response);
    } catch (error) {
      return ErrorSwitchCase(error.response.data);
    }
  };

  const updateOfficeLocation = async (payload) => {
    try {
      const response = await _axios.put(
        `${ADMIN_PATH}/office-location`,
        payload,
      );
      return ErrorSwitchCase(response);
    } catch (error) {
      return ErrorSwitchCase(error.response.data);
    }
  };

  const deleteOfficeLocation = async (payload) => {
    try {
      const response = await _axios.delete(`${ADMIN_PATH}/office-location`, {
        params: {
          locationId: payload.id,
        },
      });
      return ErrorSwitchCase(response);
    } catch (error) {
      return ErrorSwitchCase(error.response.data);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseYes = () => {
    setOpen(false);
    removeEmployeeFromLocation(statusChanged);
  };
  const removeEmployeeFromLocation = async (resource) => {
    setLoadTable(true);
    const payload = {
      id: resource.id,
      locationId: null,
      tenantId: process.env.REACT_APP_TENANT_ID,
      dateOfJoining: userData?.dateOfJoining,
      dateOfInternship: userData?.dateOfInternship,
    };
    const updateResponse = await updateEmployeeOfficeLocation(payload);
    if (updateResponse.isError === false) {
      loadData();
      setLoadTable(false);
    }
  };

  const columns = [
    {
      field: 'employeeName',
      headerName: 'Name',
      flex: 0.8,
      sortable: true,
      hideable: false,
      valueGetter: (params) => params.row.firstName + ' ' + params.row.lastName,
      renderCell: (params) =>
        params.row.status === 'ACTIVE' ? (
          <Typography>
            {params.row.firstName + ' ' + params.row.lastName}
          </Typography>
        ) : (
          <Typography sx={{ color: 'gray' }}>
            {params.row.firstName + ' ' + params.row.lastName}
          </Typography>
        ),
    },
    {
      field: 'employeeDesignation',
      headerName: 'Designation',
      flex: 0.6,
      sortable: true,
      valueGetter: (params) => params?.row?.designation,
      renderCell: (params) =>
        params.row.status === 'ACTIVE' ? (
          <Typography>{params.row.designation}</Typography>
        ) : (
          <Typography sx={{ color: 'gray' }}>
            {params.row.designation}
          </Typography>
        ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.3,
      sortable: false,
      renderCell: (params) => (
        <>
          <Switch
            size="small"
            checked={params.row.status === 'ACTIVE'}
            onChange={() => {
              toggleEmployeeLocation(params.row);
            }}
            disabled={oneOffice.status !== 'ACTIVE'}
          />
        </>
      ),
    },
  ];

  return (
    <Card variant="outlined" sx={{ mb: 1 }}>
      {loading ? (
        ''
      ) : (
        <Box>
          <Box className="office-container" style={{ overflow: 'auto' }}>
            <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box style={{ display: 'flex', alignItems: 'flex-start' }}>
                <Typography
                  variant="h6"
                  noWrap
                  sx={{
                    fontFamily: 'sans-serif',
                    fontSize: '1.7rem',
                    textTransform: 'capitalize',
                    color: oneOffice.status !== 'ACTIVE' ? 'gray' : 'navy',
                    marginBottom: '0.8rem',
                  }}
                >
                  {office.locationName}
                </Typography>
                {(KeycloakService.hasRole([UserType.ADMIN]) ||
                  KeycloakService.hasRole([UserType.HR])) && (
                  <IconButton
                    color="primary"
                    onClick={() => {
                      if (currentOfficeId === office.id) {
                        getOfficeLocationById(office.id);
                        setExpanded(!expanded);
                        ScrollToTop();
                      } else {
                        getOfficeLocationById(office.id);
                        setExpanded(true);
                        ScrollToTop();
                      }
                    }}
                    disabled={oneOffice.status !== 'ACTIVE'}
                  >
                    <Tooltip title="Edit" arrow>
                      <CreateSharpIcon
                        sx={{
                          fontSize: 18,
                          color:
                            oneOffice.status !== 'ACTIVE'
                              ? 'gray'
                              : 'slateblue',
                          marginTop: 0.7,
                        }}
                      />
                    </Tooltip>
                  </IconButton>
                )}
              </Box>
              <Box>
                {(KeycloakService.hasRole([UserType.ADMIN]) ||
                  KeycloakService.hasRole([UserType.HR])) && (
                  <FormControlLabel
                    sx={{ marginLeft: 0, marginRight: 0 }}
                    label={
                      oneOffice.status === 'ACTIVE' ? (
                        <Typography sx={{ color: '#4d6cd9' }}>
                          Active
                        </Typography>
                      ) : (
                        <Typography sx={{ color: '#717982' }}>
                          Inactive
                        </Typography>
                      )
                    }
                    labelPlacement="start"
                    control={<Android12Switch color="success" />}
                    checked={oneOffice.status === 'ACTIVE'}
                    size="small"
                    onChange={() => setOpens(!opens)}
                  />
                )}
                {addExpand ? (
                  <IconButton
                    sx={{ paddingBottom: 1.6, display: 'none' }}
                    color="primary"
                    onClick={() => {
                      toggleAddEmployee();
                    }}
                  >
                    <PersonAddAltIcon />
                  </IconButton>
                ) : (
                  <Tooltip title="Add Employees" arrow>
                    <span>
                      <IconButton
                        sx={{ paddingBottom: 1.6 }}
                        color="primary"
                        onClick={() => {
                          toggleAddEmployee();
                        }}
                        disabled={oneOffice.status !== 'ACTIVE'}
                      >
                        <PersonAddAltIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
                <DialogBoxComponent
                  open={opens}
                  handleClose={handleOfficeStatusNo}
                  confirmText={YES_TEXT}
                  cancelText={NO_TEXT}
                  content={
                    (oneOffice.status === 'ACTIVE'
                      ? 'You are about to archive '
                      : 'You are about to activate ') +
                    oneOffice.locationName +
                    '. Continue?'
                  }
                  onConfirm={handleOfficeStatusYes}
                  onCancel={handleOfficeStatusNo}
                  icon={<WarningIcon color="warning" />}
                />
              </Box>
            </Box>
            {!addExpand ? (
              ''
            ) : (
              <Box
                style={{
                  marginLeft: '-10px',
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}
              >
                <Box style={{ flexBasis: '70%' }}>
                  <AddEmployee
                    ref={selectNameRef}
                    currentOfficeEmployees={officeEmployees}
                  />
                  {warning ? (
                    <Box style={{ color: 'red' }}>
                      <small>Please Enter a valid name</small>
                    </Box>
                  ) : (
                    ''
                  )}
                </Box>
                <Box>
                  <IconButton
                    color="success"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    <DoneIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => {
                      toggleAddEmployee();
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Box>
            )}
            <Box
              className="office-card-subhead"
              sx={{
                color: oneOffice.status !== 'ACTIVE' ? 'gray' : '',
              }}
            >
              <strong>Employees</strong>
            </Box>
            <Box style={{ height: '350px' }}>
              <DataGrid
                sx={{
                  color: oneOffice.status !== 'ACTIVE' ? 'gray' : '',
                  ...DATAGRID_FILTER_CONFIG,
                }}
                rows={officeEmployees}
                columns={columns}
                hideFooter
                components={{
                  LoadingOverlay: LinearProgress,
                }}
                loading={loadTable}
              />
              <DialogBoxComponent
                open={open}
                handleClose={handleClose}
                content={
                  `${WARNING_TEXT_FIRST}
                            remove ` +
                  statusChanged.firstName +
                  ' ' +
                  statusChanged.lastName +
                  ' from ' +
                  office.locationName +
                  `${WARNING_TEXT_SECOND}`
                }
                icon={<WarningAmberIcon color="warning" />}
                onConfirm={handleCloseYes}
                onCancel={handleClose}
                confirmText={YES_TEXT}
                cancelText={NO_TEXT}
              />
            </Box>
          </Box>
        </Box>
      )}
    </Card>
  );
};
export default OfficeLocationCardComponent;
